<template>
  <v-container
    id="finaliza-compra-form"
    fluid
    tag="section"
    class="px-3 pt-0"
    style="margin-top: 1rem"
  >
    <v-row>
      <v-col
        cols="12"
        lg="12"
        class="px-1"
      >
        <!-- FORMULARIO DE USUARIO NAO IDENTIFICADO ------------------------------------------------->
        <usuario-nao-identificado-form
          v-if="!usuarioIdentificado"
          :titulo="$t('finaliza-compra')"
        />
        <base-material-card
          v-else
          :color="corPrimaria"
          :title="$t('finaliza-compra')"
          :app-online="appOnline"
          class="py-3 px-5"
        >
          <template v-slot:heading>
            <div
              class="text-h3 font-bold-light"
            >
              <v-icon
                id="iconCart"
                class="text-h2"
              >
                mdi-cart-arrow-right
              </v-icon>
              Finalizar Pedido
            </div>
          </template>
        </base-material-card>
        <v-divider class="mb-5" />
        <v-row>
          <v-col
            cols="4"
          >
            <div class="col-12">
              <div class="col-12">
                <h3>
                  Endereço para entrega
                </h3>
                <div v-if="dados">
                  <div>
                    {{ dados.logradouro }} {{ dados.numero }} {{ dados.complemento }} {{ dados.bairro }} {{ dados.cep }} {{ dados.localidade }} {{ dados.uf }}
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div>
                  <template>
                    <v-container
                      v-if="paymentClient"
                      id="paymentClient"
                      fluid
                    >
                      <h3>
                        Opção de Pagamento
                      </h3>
                      <v-row align="center">
                        <v-col
                          class="d-flex"
                          cols="12"
                          sm="8"
                        >
                          <tex-field-with-validation
                            v-model="paymentClient.nome"
                            rules="required"
                            prepend-icon="mdi-credit-card-marker"
                            disabled
                          />
                        </v-col>
                      </v-row>
                    </v-container>
                    <v-container
                      v-else
                      id="paymentClient"
                      fluid
                    >
                      <h3>
                        Opções de Pagamento
                      </h3>
                      <v-row align="center">
                        <v-col
                          class="d-flex"
                          cols="12"
                          sm="8"
                        >
                          <v-select
                            v-model="select"
                            :items="payment"
                            item-value="id"
                            item-text="nome"
                            label="Forma de pagamento"
                            prepend-icon="mdi-credit-card-marker"
                            return-object
                            @change="UpdateCarrinho()"
                          />
                        </v-col>
                      </v-row>
                    </v-container>
                  </template>
                </div>
              </div>
            </div>
          </v-col>
          <v-col cols="8">
            <div
              v-if="cartList"
              id="cartIten"
              class="col-12"
            >
              <h3>Itens do Pedido</h3>
              <template>
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">
                          Nome
                        </th>
                        <th class="text-left">
                          Preço
                        </th>
                        <th class="text-justify">
                          Quantidade(s)
                        </th>
                        <th class="text-justify">
                          Peça(s)
                        </th>
                        <th class="text-justify">
                          Caixa
                        </th>
                        <th class="text-left">
                          SubTotal
                        </th>
                        <th class="text-left">
                          Editar
                        </th>
                        <th class="text-left">
                          Excluir
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="lista in cartList"
                        :key="lista.id"
                      >
                        <td>
                          {{ lista.nome }}
                        </td>
                        <td class="text-center">
                          {{ lista.precoExibicao }}
                        </td>
                        <td class="text-center">
                          {{ lista.quantidade }}
                        </td>
                        <td class="text-center">
                          {{ lista.pecas }}
                        </td>
                        <td class="text-center">
                          <div v-if="lista.caixa">
                            {{ lista.caixa }}
                          </div>
                          <div v-else>
                            -
                          </div>
                        </td>
                        <td class="text-left">
                          {{ lista.subtotal }}
                        </td>
                        <td class="text-left">
                          <v-icon
                            id="iconCart"
                            class="text-h2"
                            :color="corPrimaria"
                            @click="showModal(lista)"
                          >
                            mdi-pencil
                          </v-icon>
                        </td>
                        <td class="text-left">
                          <v-icon
                            id="iconCart"
                            class="text-h2"
                            :color="corError"
                            @click="removeProduto(lista)"
                          >
                            mdi-delete
                          </v-icon>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
                <hr><br>
                <v-row
                  v-if="total"
                >
                  <v-col
                    id="idTotal"
                    class="text-left"
                  >
                    TOTAL
                  </v-col>
                  <v-col
                    id="total"
                    class="text-right"
                  >
                    {{ total }}
                  </v-col>
                </v-row>
                <div class="text-right">
                  <v-btn
                    id="btnFinalizar"
                    class="ma-2 col-3 col-sm-3"
                    :loading="loading"
                    :disabled="loading"
                    :color="corPrimaria"
                    @click="loader = 'loading', finalizarPedido()"
                  >
                    <v-icon>
                      mdi-cart-arrow-up
                    </v-icon>
                    <h5>Finalizar Pedido</h5>
                    <template v-slot:loader>
                      <span>Enviando Pedido...</span>
                    </template>
                  </v-btn>
                </div>
              </template>
            </div>
            <div
              v-else
            >
              <h3>Não há itens no pedido.</h3>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
    <v-row justify="center">
      <v-dialog
        v-model="dialog.visible"
        transition="dialog-bottom-transition"
        persistent
        max-width="600px"
        @keydown.esc="dialog.visible = false"
      >
        <v-card>
          <v-card-title>
            <v-spacer />
            <v-icon
              aria-label="Close"
              @click="dialog.visible = false"
            >
              mdi-close
            </v-icon>
          </v-card-title>
          <v-card-text class="text-center">
            <h4>{{ dialog.message }}</h4>
          </v-card-text>
          <v-card-text class="pb-3 pt-6 text-center">
            <v-container>
              <v-row v-if="exibirCaixa">
                <v-col
                  cols="12"
                  sm="6"
                  md="6"
                >
                  <v-text-field
                    v-model="produto.nome"
                    label="Item"
                    disabled
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="2"
                >
                  <v-text-field
                    v-model="produto.unidade"
                    label="Unidade"
                    disabled
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="2"
                >
                  <v-text-field
                    v-model="produto.quantidade"
                    label="Quantidade(s)"
                    disabled
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="2"
                >
                  <v-text-field
                    v-model="produto.pecas"
                    label="Peça(s)"
                    disabled
                  />
                </v-col>
              </v-row>
              <v-row v-if="exibirPecas">
                <v-col
                  cols="12"
                  sm="6"
                  md="6"
                >
                  <v-text-field
                    v-model="produto.nome"
                    label="Item"
                    disabled
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="2"
                >
                  <v-text-field
                    v-if="produto.unidade"
                    v-model="produto.unidade"
                    label="Unidade"
                    disabled
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="2"
                >
                  <v-text-field
                    v-if="produto.quantidade"
                    v-model="produto.quantidade"
                    label="Quantidade(s)"
                    disabled
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="2"
                >
                  <v-text-field
                    v-if="produto.caixa"
                    v-model="produto.caixa"
                    label="Caixa(s)"
                    disabled
                  />
                </v-col>
              </v-row>
              <v-row v-if="exibirQuantidade">
                <v-col
                  cols="12"
                  sm="6"
                  md="6"
                >
                  <v-text-field
                    v-model="produto.nome"
                    label="Item"
                    disabled
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="2"
                >
                  <v-text-field
                    v-if="produto.unidade"
                    v-model="produto.unidade"
                    label="Unidade"
                    disabled
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="2"
                >
                  <v-text-field
                    v-if="produto.pecas"
                    v-model="produto.pecas"
                    label="Peça(s)"
                    disabled
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="2"
                >
                  <v-text-field
                    v-if="produto.caixa"
                    v-model="produto.caixa"
                    label="Caixa(s)"
                    disabled
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  class="center"
                >
                  <div>
                    <div v-if="exibirCaixa">
                      Caixa(s):
                    </div>
                    <div v-if="exibirPecas">
                      Peça(s):
                    </div>
                    <div v-if="exibirQuantidade">
                      Quantidade:
                    </div>
                    <div class="my-2">
                      <v-btn
                        id="btnUpdateCart"
                        small
                        :color="corError"
                        dark
                        @click="removeItem(produto)"
                      >
                        <v-icon color="#ffffff">
                          mdi-minus
                        </v-icon>
                      </v-btn>
                      <input
                        v-if="exibirCaixa"
                        id="input_cart"
                        v-model="produto.caixa"
                        v-mask="['###############']"
                        pattern="^[0-9]"
                        type="text"
                        class="text-center"
                        style="width: 50px"
                        @keyup="produto.caixa <= 0 ? removeItem(produto) : atualizaListaCompraKeyup(produto)"
                        @keyup.enter="close()"
                      >
                      <input
                        v-if="exibirPecas"
                        id="input_cart"
                        v-model="produto.pecas"
                        v-mask="['###############']"
                        pattern="^[0-9]"
                        type="text"
                        class="text-center"
                        style="width: 50px"
                        @keyup="produto.pecas <= 0 ? removeItem(produto) : atualizaListaCompraKeyup(produto)"
                        @keyup.enter="close()"
                      >
                      <input
                        v-if="exibirQuantidade"
                        id="input_cart"
                        v-model="produto.quantidade"
                        v-mask="['###############']"
                        pattern="^[0-9]"
                        type="text"
                        class="text-center"
                        style="width: 50px"
                        @keyup="produto.quantidade <= 0 ? removeItem(produto) : atualizaListaCompraKeyup(produto)"
                        @keyup.enter="close()"
                      >
                      <v-btn
                        id="btnUpdateCart"
                        small
                        :color="corSecondaria"
                        dark
                        @click="addItem(produto)"
                      >
                        <v-icon color="#ffffff">
                          mdi-plus
                        </v-icon>
                      </v-btn><br><br>
                      <v-btn
                        id="btnConfirmar"
                        :color="corPrimaria"
                        dark
                        @click="close()"
                      >
                        <v-icon color="#ffffff">
                          mdi-check
                        </v-icon>
                        Confirmar
                      </v-btn>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="dialog2.visible"
        max-width="411"
        persistent
        @keydown.esc="close()"
      >
        <v-card>
          <v-card-title>
            <v-spacer />
          </v-card-title>
          <v-card-text class="text-center">
            {{ dialog2.message }}
          </v-card-text>
          <v-card-text class="pb-3 pt-6 text-center">
            <v-btn
              class="mr-3"
              :color="corError"
              text
              @click="resetProduto(dialog2.produto), dialog2.visible = false"
            >
              Não
            </v-btn>

            <v-btn
              :color="corSecondaria"
              text
              @click="confirmRemoveProduto(dialog2.produto) ,dialog2.visible = false"
            >
              Sim
            </v-btn>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
  import utils from '../../../services/utils'
  import Carrinho from '../../../services/carrinhoservice'
  import OpcaoPagamento from '../../../services/opcaopagamentoservice'
  import PedidoVenda from '../../../services/pedidovendaservice'

  export default {
    name: 'PageCarrinhoCompras',
    components: {
      DashboardCoreSnackbar: () => import('../components/core/Snackbar'),
    },
    mixins: [utils],
    data: () => ({
      appOnline: navigator.onLine,
      usuarioIdentificado: localStorage.usuarioIdentificado,
      username: localStorage.username,
      tokencontrato: localStorage.tokencontrato,
      chaveativacao: localStorage.chaveativacao,
      valid: true,
      loader: null,
      loading: false,
      cartShopping: [],
      cartList: [],
      listItens: [],
      cart: 0,
      dados: [],
      select: {},
      payment: [],
      paymentClient: [],
      items: [],
      produto: [],
      total: null,
      exibirCaixa: false,
      exibirPecas: false,
      exibirQuantidade: false,
      bloqueado: localStorage.bloqueado,
      obsBloqueado: localStorage.obsBloqueado,
      corPrimaria: localStorage.corPrimaria,
      corSecondaria: localStorage.corSecondaria,
      inativo: 0,
      corError: localStorage.corError,
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      dialog: {
        visible: false,
        message: '',
      },
      dialog2: {
        visible: false,
        message: '',
      },
      styleObjectError: {
        color: localStorage.corError,
      },
      styleObjectPromocao: {
        color: '#FFFFFF',
      },
    }),

    watch: {
      loader () {
        const l = this.loader
        this[l] = !this[l]

        setTimeout(() => (this[l] = false), 3000)

        this.loader = null
      },
    },

    mounted () {
      if (this.chaveativacao && this.chaveativacao !== 'undefined') {
        // this.chaveativacao = localStorage.chaveativacao
        // if (localStorage.getItem('usuarioIdentificado') && localStorage.getItem('usuarioIdentificado') === 'true') {
        if (this.usuarioIdentificado) {
          // this.usuarioIdentificado = true

          localStorage.removeItem('produtoId')
          localStorage.removeItem('linhaSelect')
          localStorage.removeItem('classificacaoSelect')

          this.carregaForm()
        } else {
          this.usuarioIdentificado = false
          localStorage.removeItem('username')
          localStorage.removeItem('email')
          localStorage.removeItem('nome')
          localStorage.removeItem('produtoId')
          localStorage.removeItem('linhaSelect')
          localStorage.removeItem('classificacaoSelect')
          this.$router.push('/login')
        }
      } else {
        localStorage.removeItem('username')
        localStorage.removeItem('email')
        localStorage.removeItem('produtoId')
        localStorage.removeItem('nome')
        this.$router.push('/login')
      }
    },

    methods: {
      carregaForm () {
        this.carregaProdutos()
        this.carregaOpcaoPagamento()
        this.carregaEndereco()
      },

      async carregaProdutos () {
        await Carrinho.show(this.username, this.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            this.cartShopping = resposta.data.carrinho
            this.cartList = resposta.data.itensCarrinho
            this.listItens = resposta.data.itensCarrinho

            this.bloqueado = resposta.data.bloqueado
            this.inativo = resposta.data.inativo

            localStorage.bloqueado = this.bloqueado
            localStorage.inativo = this.inativo

            this.exibirCaixa = resposta.data.exibirCaixa
            this.exibirPecas = resposta.data.exibirPecas
            this.exibirQuantidade = resposta.data.exibirQuantidade

            this.total = this.cartShopping.total.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            this.mapCartList()

            this.cart = this.cartList.length

            this.updateCart()
          } else if (resposta.data.msg === 'Não há itens no carrinho') {
            this.cart = 0
            this.total = null
            this.updateCart()
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        })
      },

      async carregaOpcaoPagamento () {
        await OpcaoPagamento.show(this.tokencontrato).then(resposta => {
          this.payment = resposta.data.opcoes
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        })

        await OpcaoPagamento.showOptionClient(localStorage.username, this.tokencontrato).then(resposta => {
          this.paymentClient = resposta.data.opcao
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        })
      },

      async UpdateCarrinho () {
        if (this.cartShopping) {
          await Carrinho.updateItemOptionPayment(this.select, this.tokencontrato, this.cartShopping.id).then(resposta => {
            if (resposta.data.status) {
              this.cartShopping = resposta.data.carrinho
              this.cartList = resposta.data.itensCarrinho
              this.listItens = resposta.data.itensCarrinho

              this.total = this.cartShopping.total.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

              this.mapCartList()

              this.cart = this.cartList.length

              this.updateCart()
            }
          }).catch(e => {
            if (e.message === 'Network Error') {
              this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
            }
          })
        }
      },

      async carregaEndereco () {
        await OpcaoPagamento.endereco(this.username, this.tokencontrato).then(resposta => {
          this.dados = resposta.data.dados
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        })
      },

      async finalizarPedido () {
        if (this.select.Contrato) {
          await PedidoVenda.saveOrder(this.listItens, this.cartShopping, this.dados, this.select).then(resposta => {
            if (resposta.data.msg === 'Pedido cadastrado com sucesso.') {
              this.showSnackbar(this.corPrimaria, 2000, 'Pedido cadastrado com sucesso.')

              this.cartList.length = 0

              this.cart = 0

              this.updateCart()

              this.$router.push('/lista-pedido')
            } else if (resposta.data.msg === 'ORDER: Produto com preço zerado.') {
              this.showSnackbar(this.corPrimaria, 13000, resposta.data.text)

              this.cartShopping = resposta.data.carrinho
              this.cartList = resposta.data.itensCarrinho
              this.listItens = resposta.data.itensCarrinho

              this.total = this.cartShopping.total.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

              this.mapCartList()

              this.cart = this.cartList.length

              this.updateCart()
            } else if (resposta.data.msg === 'Erro na finalização do pedido.') {
              this.showSnackbar('error', 2000, 'Erro no confirmação do pedido, verifique sua conexão e tente novamente mais tarde.')
            }
          }).catch(e => {
            if (e.message === 'Network Error') {
              this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
            } else if (e.data.msg === 'ERRO ORDER: Produto com preço zerado.') {
              this.showSnackbar('error', 10000, e.data.text)
            } else if (e.data.msg === 'Cliente não encontrado') {
              this.showSnackbar('error', 3000, 'Cliente não encontrado.')
            } else if (e.data.msg === 'Usuário não encontrado') {
              this.showSnackbar('error', 3000, 'Usuário não encontrado')
            } else if (e.data.msg === 'Cliente não encontrado') {
              this.showSnackbar('error', 3000, 'Contrato não encontrado')
            } else if (e.data.msg === 'Erro ao salvar pedido') {
              this.showSnackbar('error', 3000, 'Erro ao salvar pedido')
            } else if (e.data.text === 'cliente bloqueado') {
              this.showSnackbar('error', 3000, e.data.message)
            }
          })
        } else if (this.paymentClient) {
          await PedidoVenda.saveOrder(this.listItens, this.cartShopping, this.dados, this.paymentClient).then(resposta => {
            if (resposta.data.msg === 'Pedido cadastrado com sucesso.') {
              this.showSnackbar(this.corPrimaria, 2000, 'Pedido cadastrado com sucesso.')

              this.cartList.length = 0

              this.cart = 0

              this.updateCart()

              this.$router.push('/lista-pedido')
            } else if (resposta.data.msg === 'ORDER: Produto com preço zerado.') {
              this.showSnackbar(this.corPrimaria, 13000, resposta.data.text)

              this.cartShopping = resposta.data.carrinho
              this.cartList = resposta.data.itensCarrinho
              this.listItens = resposta.data.itensCarrinho

              this.total = this.cartShopping.total.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

              this.mapCartList()

              this.cart = this.cartList.length

              this.updateCart()
            } else if (resposta.data.msg === 'Erro na finalização do pedido.') {
              this.showSnackbar('error', 2000, 'Erro no confirmação do pedido, verifique sua conexão e tente novamente mais tarde.')
            }
          }).catch(e => {
            if (e.message === 'Network Error') {
              this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
            } else if (e.data.msg === 'ERRO ORDER: Produto com preço zerado.') {
              this.showSnackbar('error', 15000, e.data.text)
            } else if (e.data.msg === 'Cliente não encontrado') {
              this.showSnackbar('error', 3000, 'Cliente não encontrado.')
            } else if (e.data.msg === 'Usuário não encontrado') {
              this.showSnackbar('error', 3000, 'Usuário não encontrado')
            } else if (e.data.msg === 'Cliente não encontrado') {
              this.showSnackbar('error', 3000, 'Contrato não encontrado')
            } else if (e.data.msg === 'Erro ao salvar pedido') {
              this.showSnackbar('error', 3000, 'Erro ao salvar pedido')
            } else if (e.data.text === 'cliente bloqueado') {
              this.showSnackbar('error', 10000, e.data.message)
            }
          })
        } else {
          alert('Favor selecionar uma forma de pagamento para poder finalizar o pedido.')
        }
      },

      mapCartList () {
        const carrinholista = this.cartList.map((value) => {
          var listacompra = ({
            id: value.id,
            idProduto: value.idProduto,
            carrinhoId: value.carrinhoId,
            nome: value.nome,
            unidade: value.unidade,
            preco: value.preco,
            precoExibicao: value.precoExibicao.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            quantidade: value.quantidade,
            pecasPorCaixa: value.pecasPorCaixa,
            pecas: value.pecas,
            caixa: value.caixa,
            referenciaUnidade: value.referenciaUnidade,
            peso: value.peso,
            subtotal: value.subtotal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            fimPromocao: value.fimPromocao,
          })

          return listacompra
        })

        this.cartList = carrinholista
      },

      showModal (produto) {
        if (produto.nome !== 'TOTAL') {
          this.produto = produto
          this.showDialog('Editar item do pedido', produto)
        }
      },

      addItem (produto) {
        if (this.exibirCaixa) {
          produto.caixa = produto.caixa ? parseFloat(produto.caixa) : 0

          produto.caixa = produto.caixa += 1

          produto.pecas = produto.caixa * produto.pecasPorCaixa
          produto.quantidade = ((produto.referenciaUnidade * produto.pecasPorCaixa) * produto.caixa).toFixed(2)
        } else if (this.exibirPecas) {
          produto.pecas = parseFloat(produto.pecas)

          produto.pecas += 1

          produto.caixa = produto.caixa ? Math.ceil(produto.pecas / (produto.pecasPorCaixa ?? 1)) : 1
          produto.quantidade = (produto.pecas * produto.referenciaUnidade).toFixed(2)
        } else if (this.exibirQuantidade) {
          produto.quantidade = parseFloat(produto.quantidade)

          produto.quantidade += 1

          produto.pecas = Math.ceil(produto.quantidade / (produto.referenciaUnidade ?? 1))
          produto.caixa = produto.caixa ? Math.ceil((produto.quantidade / (produto.referenciaUnidade ?? 1)) / (produto.pecasPorCaixa ?? 1)) : 1
        }

        this.atualizarPedido(produto)
      },

      removeItem (produto) {
        if (this.exibirCaixa) {
          produto.caixa -= 1

          produto.pecas = produto.caixa * produto.pecasPorCaixa
          produto.quantidade = ((produto.referenciaUnidade * produto.pecasPorCaixa) * produto.caixa).toFixed(2)

          if (produto.caixa < 0) {
            produto.caixa = 0
          }

          if (produto.caixa <= 0) {
            this.showDialog2('Tem certeza que deseja remover este produto?', produto)
            this.updateCart()
          } else {
            this.atualizarPedido(produto)
          }
        } else if (this.exibirPecas) {
          produto.pecas -= 1

          produto.caixa = produto.caixa ? Math.ceil(produto.pecas / produto.pecasPorCaixa) : 0
          produto.quantidade = (produto.pecas * produto.referenciaUnidade).toFixed(2)

          if (produto.pecas < 0) {
            produto.pecas = 0
          }

          if (produto.pecas <= 0) {
            this.showDialog2('Tem certeza que deseja remover este produto?', produto)
            this.updateCart()
          } else {
            this.atualizarPedido(produto)
          }
        } else if (this.exibirQuantidade) {
          produto.quantidade -= 1

          produto.pecas = Math.ceil(produto.quantidade / produto.referenciaUnidade)
          produto.caixa = produto.caixa ? Math.ceil((produto.quantidade / produto.referenciaUnidade) / produto.pecasPorCaixa) : 0

          if (produto.quantidade < 0) {
            produto.quantidade = 0
          }

          if (produto.quantidade <= 0) {
            this.showDialog2('Tem certeza que deseja remover este produto?', produto)
            this.updateCart()
          } else {
            this.atualizarPedido(produto)
          }
        }
      },

      removeProduto (produto) {
        produto.pecas = 0
        produto.caixa = 0
        produto.quantidade = 0

        this.showDialog2('Tem certeza que deseja remover este produto?', produto)
      },

      confirmRemoveProduto (produto) {
        var indice = this.cartList.indexOf(produto)

        this.cartList.splice(indice, 1)

        this.showSnackbar(this.corPrimaria, 2000, 'Produto removido do pedido.')

        this.atualizarPedido(produto)

        this.updateCart()

        this.dialog.visible = false
      },

      resetProduto (produto) {
        if (this.exibirCaixa) {
          produto.caixa = 1
          produto.pecas = produto.caixa * produto.pecasPorCaixa
          produto.quantidade = ((produto.referenciaUnidade * produto.pecasPorCaixa) * produto.caixa).toFixed(2)
        } else if (this.exibirPecas) {
          produto.pecas = 1
          produto.caixa = Math.ceil(produto.pecas / produto.pecasPorCaixa)
          produto.quantidade = (produto.pecas * produto.referenciaUnidade).toFixed(2)
        } else if (this.exibirQuantidade) {
          produto.quantidade = 1
          produto.pecas = Math.ceil(produto.quantidade / produto.referenciaUnidade)
          produto.caixa = Math.ceil((produto.quantidade / produto.referenciaUnidade) / produto.pecasPorCaixa)
        }

        this.showSnackbar(this.corPrimaria, 2000, 'Produto não foi removido do carrinho.')

        this.atualizarPedido(produto)
      },

      atualizaListaCompraKeyup (produto) {
        if (this.exibirCaixa) {
          produto.caixa = produto.caixa ? parseFloat(produto.caixa) : 0

          produto.pecas = produto.caixa * produto.pecasPorCaixa
          produto.quantidade = ((produto.referenciaUnidade * produto.pecasPorCaixa) * produto.caixa).toFixed(2)

          this.atualizarPedido(produto)
        } else if (this.exibirPecas) {
          produto.pecas = parseFloat(produto.pecas)

          produto.caixa = produto.caixa ? Math.ceil(produto.pecas / produto.pecasPorCaixa) : 0
          produto.quantidade = (produto.pecas * produto.referenciaUnidade).toFixed(2)

          this.atualizarPedido(produto)
        } else if (this.exibirQuantidade) {
          produto.quantidade = parseFloat(produto.quantidade)

          produto.pecas = Math.ceil(produto.quantidade / produto.referenciaUnidade)
          produto.caixa = produto.caixa ? Math.ceil((produto.quantidade / produto.referenciaUnidade) / produto.pecasPorCaixa) : 0

          this.atualizarPedido(produto)
        }
      },

      /* Método que atuliza o ícone da quantidade itens no pedido */
      updateCart () {
        this.$root.$emit('update-cart', this.cart)
      },

      close () {
        this.dialog.visible = false
      },

      async atualizarPedido (produto) {
        await Carrinho.updateItenCart(produto, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status === true) {
            produto.caixa = resposta.data.caixa
            produto.pecas = resposta.data.pecas
            produto.quantidade = resposta.data.quantidade
            produto.peso = resposta.data.peso
            produto.subtotal = resposta.data.subtotal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
            this.atualizarTotal()
            this.showSnackbar(this.corPrimaria, 2000, 'Produto atualizado com sucesso.')

            this.carregaProdutos()
          } else if (resposta.data.message === 'Item removido com sucesso.') {
            this.carregaProdutos()
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.status === false) {
            this.showSnackbar('error', 3500, e.data.message)
            this.dialog.visible = false
            this.carregaProdutos()
          }
        })
      },

      atualizarTotal () {
        var ultimo = this.cartList[this.cartList.length - 1]
        Carrinho.show(this.username, this.tokencontrato).then(resposta => {
          ultimo.subtotal = resposta.data.carrinho.total.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        })
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },

      showDialog (message, produto) {
        this.dialog.visible = true
        this.dialog.message = message
        this.dialog.produto = produto
      },

      showDialog2 (message, produto) {
        this.dialog2.visible = true
        this.dialog2.message = message
        this.dialog2.produto = produto
      },
    },
  }
</script>

<style lang="sass">
  #iconCart
    margin-bottom: 5px

  #finaliza-compra-form
    margin-top: 4em

  #input_cart
    width: 15%

  #btnFinalizar
    border-radius: 1.8rem

  #btnUpdateCart
    border-radius: 1.8rem

  #btnConfirmar
    border-radius: 1.8rem

  #btnBloqueado
    text-decoration: underline overline dotted red

  .custom-loader
    animation: loader 1s infinite
    display: flex

  .v-text-field
    font-size: 0.9rem

  #total
    margin-right: 2rem

  #idTotal
    margin-left: 1.2rem

  #paymentClient
    margin-left: -1rem

  #imgPromocao
    top: 1.5rem
    margin-left: -1.3rem

  #spanPromocao
    background-color: #E53935
    border-radius: 0.5rem

  #dataFim
    margin-top: -1.3rem

  /** CSS padrão efeito botão **/
  @-moz-keyframes loader
    from
      transform: rotate(0)
    to
      transform: rotate(360deg)

  @-webkit-keyframes loader
    from
      transform: rotate(0)
    to
      transform: rotate(360deg)

  @-o-keyframes loader
    from
      transform: rotate(0)
    to
      transform: rotate(360deg)

  @keyframes loader
    from
      transform: rotate(0)
    to
      transform: rotate(360deg)

</style>
